<template>
  <div v-if="itemsCount > 0" class="kiosk-basket-container">
    <!-- Nativer Button statt v-card, um Vuetify-CSS-Blockaden zu umgehen -->
    <button
      class="kiosk-checkout-btn checkoutButtonAnimationExtreme"
      @click.passive="gotoCart"
    >
      <div class="kiosk-flex-wrapper">

        <!-- Linke Seite: Summe -->
        <div class="price-section" v-if="!$store.getters.hidePrices">
          <span class="currency-label">Gesamt</span>
          <div class="price-amount checkoutButtonText">
            {{ $store.getters.payerSum | price }}
          </div>
        </div>

        <!-- Rechte Seite: Checkout -->
        <div class="action-section">
          <!-- Das Badge belassen wir, rücken es aber mit v-classes zurecht -->
          <v-badge
            color="error"
            :content="itemsCount"
            overlap
            offset-x="10"
            offset-y="10"
            class="flex-shrink-0"
          >
            <v-icon large class="white--text">mdi-cart-arrow-right</v-icon>
          </v-badge>

          <div class="checkout-text checkoutButtonText">
            Checkout
          </div>

          <v-icon large class="white--text arrow-right">mdi-chevron-right</v-icon>
        </div>

      </div>
    </button>
  </div>
</template>

<script>
export default {
  name: "KioskBasketButton",

  computed: {
    itemsCount() {
      const items = this.$store.getters.cartItems || [];
      let i = 0;
      for (let item of items) {
        if (item.id && (item.id.startsWith('special') || item.id.startsWith('stempel-'))) {
          continue;
        }
        i += item.count;
      }
      return i > 0 ? '' + i : '0';
    }
  },

  methods: {
    gotoCart() {
      this.$router.push({ name: 'Korb' });
    }
  }
}
</script>

<style lang="scss" scoped>
// 1. Äußerer Container fixiert unten rechts im Eck
.kiosk-basket-container {
  position: fixed !important;
  right: 30px !important;
  bottom: 30px !important;
  z-index: 9999 !important; // Extrem hoch, um über allen Menüs zu liegen
  height: 95px !important;  // Feste Kiosk-Höhe erzwungen
}

// 2. Das eigentliche Button-Element (Vuetify-unabhängig!)
.kiosk-checkout-btn {
  width: 100% !important;
  height: 100% !important;
  border: none !important;
  outline: none !important;
  padding: 0 24px !important;
  color: #ffffff !important;
  border-radius: 20px !important; // Schöne Kiosk-Rundung
  cursor: pointer;
  user-select: none;
  font-family: inherit;


  // Touch-Feedback am Kiosk
  &:active {
    transform: scale(0.95) !important;
  }
}

// 3. Flex-Struktur für die Aufteilung
.kiosk-flex-wrapper {
  display: flex !important;
  align-items: center !important;
  width: 100% !important;
  height: 100% !important;
}

// Preis-Bereich (links)
.price-section {
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  border-right: 2px solid rgba(255, 255, 255, 0.25) !important;
  padding-right: 18px !important;
  margin-right: 18px !important;
  height: 55px !important;
  flex-shrink: 0 !important;
  text-align: left !important;

  .currency-label {
    font-size: 0.8rem !important;
    text-transform: uppercase !important;
    letter-spacing: 1px !important;
    opacity: 0.8 !important;
    line-height: 1 !important;
    margin-bottom: 4px !important;
  }

  .price-amount {
    line-height: 1 !important;
    white-space: nowrap !important;
  }
}

// Action-Bereich (rechts)
.action-section {
  display: flex !important;
  align-items: center !important;
  flex-grow: 1 !important;
  min-width: 0 !important;

  .checkout-text {
    margin-left: 14px !important;
  }

  .arrow-right {
    margin-left: auto !important;
    flex-shrink: 0 !important;
  }
}

</style>
